module.exports = __webpack_public_path__ + "static/img/361.87a1e8a1.png";